import { format } from 'timeago.js';

export const toTimeAgo = (date?: Date): string => {
  return date ? format(date) : '';
};

/**
 * Parses a date string, appending 'Z' if timezone info is missing.
 * Handles ISO 8601 with or without timezone.
 */
export const parseDateWithOptionalTimezone = (dateString: string): Date => {
  // ISO 8601 timezone info: ends with 'Z' or "+hh:mm" or "-hh:mm"
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(dateString)) {
    return new Date(dateString);
  }
  // If no timezone info, treat as UTC
  return new Date(dateString + 'Z');
};

/**
 * Formats a date string to a locale date string.
 * Returns the original string if parsing fails.
 * Handles both ISO 8601 and non-ISO date strings.
 */
export const tryFormatDateString = (dateString?: string) => {
  if (!dateString) return '';
  try {
    const parsedDate = parseDateWithOptionalTimezone(dateString.trim());
    // Check if the date is valid
    if (Number.isNaN(parsedDate.getTime())) {
      return dateString;
    }
    return parsedDate.toLocaleDateString();
  } catch {
    return dateString;
  }
};
